import React from 'react'
import useNFTUserData from '../../data/useNFTUserData';
import { getWalletAddress } from '../../utils/NFTFormatedData';
import { ReactComponent as VerifiedIcon } from '../../../../assets/svg/verified.svg';
import NFTUserAvatar from '../NFTUserAvatar';
import { UserImage, UserInfo, UserInfoContainer, UserInfoLabel, UserInfoName } from './styled';
import { useHistory, useLocation } from 'react-router-dom';
import cx from '../../../../utils/cx';

interface NFTUserInfoCompactProps {
    accountAddress: string;
    currentAccountAdress?: string | any;
    label?: string;
    redirectToLink?: string;
    addressSlice?: number;
}
const NFTUserInfoCompact = (props: NFTUserInfoCompactProps) => {
    const { userData } = useNFTUserData(props.accountAddress?.toLowerCase());
    const navigator = useHistory();
    const renderUserName = () => {
        if (userData?.username) {
            return userData.username;
        } else if (props.accountAddress == "wallet" || props.currentAccountAdress?.toLowerCase() == props.accountAddress?.toLowerCase()) {
            return "You";
        } else {
            return getWalletAddress(props.accountAddress?.toLowerCase(), props.addressSlice || 4);
        }
    }

    const onClick = () => {
        if (props.redirectToLink) {
            navigator.push(props.redirectToLink.replace("{{address}}", props.accountAddress))
        }
    }

    return (
        <UserInfoContainer onClick={onClick} className={cx({ hasLink: props.redirectToLink ? true : false })}>
            <UserImage>
                <NFTUserAvatar accountAddress={props.accountAddress} profileImgUrl={userData?.profileImgUrl} height={40} width={40} />
            </UserImage>
            <UserInfo>
                {props.label && <UserInfoLabel>{props.label}</UserInfoLabel>}
                <UserInfoName title={renderUserName()}> {userData?.isVerified ? <VerifiedIcon style={{ fill: 'rgb(32, 129, 226)' }} height={20} width={20} title={"Verified User"} /> : <></>}<span>{renderUserName()}</span></UserInfoName>
            </UserInfo>
        </UserInfoContainer>
        // <span style={{ display: 'flex', alignItems: 'center' }}>
        //     {userData?.isVerified ? <VerifiedIcon style={{ fill: 'rgb(32, 129, 226)' }} height={20} width={20} title={"Verified User"} /> : <></>}
        //     <NFTUserAvatar accountAddress={props.accountAddress} profileImgUrl={userData?.profileImgUrl} height={24} width={24} style={{ marginLeft: 5, marginRight: 5 }} />
        //     {renderUserName()}
        // </span>
    )
}

export default NFTUserInfoCompact;